<app-breadcrumb></app-breadcrumb>
<div class="card mb-0">
    <div class="card-body">
        <dtg-notice-list [listType]="DtgListType.list"></dtg-notice-list>
    </div>
</div>